import { render, staticRenderFns } from "./ModalAiTest.vue?vue&type=template&id=d6c7bcce&scoped=true&"
import script from "./ModalAiTest.vue?vue&type=script&lang=js&"
export * from "./ModalAiTest.vue?vue&type=script&lang=js&"
import style0 from "./ModalAiTest.vue?vue&type=style&index=0&id=d6c7bcce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c7bcce",
  null
  
)

export default component.exports